import { Grid, Stack, Typography } from '@mui/material';
import { Box, BoxProps } from '@mui/system';
import { get, map } from 'lodash';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import dataSource from 'src/data-sources/about.json';
import { ReactComponent as AboutImage } from './assets/illustr_about.svg';
import useStyles from './styles';

export const About: ComponentType<BoxProps> = (props) => {
  const classes = useStyles();
  const { i18n } = useTranslation();
  const locale = i18n.language;

  const localizedData = get(dataSource, locale, {});

  return (
    <Box className={classes.root} {...props}>
      <Grid container justifyContent="space-between">
        <Grid item xs={12} md={6}>
          <Typography variant="h1" component="h2" mb={3}>
            {localizedData.title}
          </Typography>
          <Stack spacing={1}>
            {map(localizedData.body, (string, index) => (
              <Typography
                variant="body2"
                key={index}
                dangerouslySetInnerHTML={{ __html: string }}
              />
            ))}
          </Stack>
        </Grid>
        <Grid item>
          <AboutImage />
        </Grid>
      </Grid>
    </Box>
  );
};
